import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { SelectPopover } from 'ariakit/select';
import { Box } from '../Box/index.js';
import { selectPopoverStyles } from './styles.js';

/**
 *  @deprecated Please use Select for future implementation
 */
const SelectDropdownAlpha = props => {
  const {
    recalcuatePopoverPosition = true,
    autoFocusOnHide = false,
    onClick
  } = props;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    as: SelectPopover,
    autoFocusOnHide: autoFocusOnHide,
    maxHeight: "300px",
    overflow: "auto",
    zIndex: "dropdown"
  }, selectPopoverStyles, props, {
    onClick: e => {
      recalcuatePopoverPosition && props.state.render();
      onClick && onClick(e);
    }
  }));
};

export { SelectDropdownAlpha };
